import { defineRecipe } from '@plurall/elo-v3';

export const learningPathsToolbarRootRecipe = defineRecipe({
  className: 'learning-paths-toolbar',
  base: {
    display: 'flex',
    flexDirection: { base: 'column', md: 'row' },
    alignItems: { base: 'stretch', md: 'center' },
    gap: 'gap.medium',
    marginBlockEnd: 'gap.large',
  },
});

export const learningPathsToolbarSearchRecipe = defineRecipe({
  className: 'learning-paths-toolbar__search',
  base: {
    flex: 1,
    minWidth: 0,
  },
});

export const learningPathsToolbarFieldRecipe = defineRecipe({
  className: 'learning-paths-toolbar__field',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'space.8',
    '& > span': {
      color: 'text.secondary',
      textStyle: 'label.small.regular',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },
  },
});
